// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/date-input","toggleCalendarButton":"date-input-m__toggleCalendarButton__2lk3t button-m__nativeResetRoot__18WbL","popup":"date-input-m__popup__1Fnww"};